/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { motion } from 'framer-motion';

const Project = ({ item }) => {
    const [isOpen, SetIsOpen] = useState(false);

    return (
        <motion.div
            className='p-2 bg-slate-100 dark:bg-slate-800 rounded-custom flex flex-col md:flex-row gap-2 cursor-pointer w-full md:w-auto'
            layout
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            transition={{ layout: { duration: .5, type: "spring" } }}
            onClick={() => SetIsOpen(!isOpen)}
        >
            <motion.img layout="position" src={item.image.url} alt={item.name} className="w-full md:w-[280px] h-[280px] rounded-custom " />

            {isOpen && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className='w-full'
                >
                    <motion.div layout="position" className='flex flex-col justify-between h-full'>
                        <div>
                            <motion.h3 layout="position" className='text-center md:text-left font-semibold text-2xl text-slate-900 dark:text-white tracking-wide capitalize mb-1'>{item.name}</motion.h3>
                            <motion.div className='flex flex-wrap gap-1 justify-center md:justify-start mb-1'>
                                {item.technology.map(technology => <motion.p layout="position" className='text-slate-800 font-semibold text-center md:text-left px-2 bg-white/50 rounded-custom'>{technology}</motion.p>)}
                            </motion.div>
                            <motion.p className='text-slate-500 text-center md:text-left mb-3'>{item.desc}</motion.p>
                        </div>

                        <motion.div className='flex justify-between md:justify-start gap-2'>
                            <button onClick={() => window.open(`${item.githuburl}`, "_blank")} className={`bg-skin-fill px-4 py-1 text-lg rounded-custom text-white w-1/2 md:w-[200px] text-center font-semibold uppercase ${!item.githuburl && 'disabled:opacity-50 cursor-not-allowed'}`} disabled={!item.githuburl && 'disabled'}>View</button>
                            <button onClick={() => window.open(`${item.demourl}`, "_blank")} className={`bg-skin-fill px-4 py-1 text-lg rounded-custom text-white w-1/2 md:w-[200px] text-center font-semibold uppercase ${!item.githuburl && 'disabled:opacity-50 cursor-not-allowed'}`} disabled={!item.demourl && 'disabled'}>Demo</button>
                        </motion.div>
                    </motion.div>

                </motion.div>
            )}
        </motion.div>
    )
}

export default Project